/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { EnumerationOptionDto } from './EnumerationOptionDto';
import {
    EnumerationOptionDtoFromJSON,
    EnumerationOptionDtoFromJSONTyped,
    EnumerationOptionDtoToJSON,
} from './EnumerationOptionDto';
import type { EvaluationState } from './EvaluationState';
import {
    EvaluationStateFromJSON,
    EvaluationStateFromJSONTyped,
    EvaluationStateToJSON,
} from './EvaluationState';
import type { EntityOrigin } from './EntityOrigin';
import {
    EntityOriginFromJSON,
    EntityOriginFromJSONTyped,
    EntityOriginToJSON,
} from './EntityOrigin';
import type { PtwCommentDto } from './PtwCommentDto';
import {
    PtwCommentDtoFromJSON,
    PtwCommentDtoFromJSONTyped,
    PtwCommentDtoToJSON,
} from './PtwCommentDto';
import type { BeamConstancyWorkResultDtoCreatorUser } from './BeamConstancyWorkResultDtoCreatorUser';
import {
    BeamConstancyWorkResultDtoCreatorUserFromJSON,
    BeamConstancyWorkResultDtoCreatorUserFromJSONTyped,
    BeamConstancyWorkResultDtoCreatorUserToJSON,
} from './BeamConstancyWorkResultDtoCreatorUser';

/**
 * 
 * @export
 * @interface EnumerationEvaluationResultDto
 */
export interface EnumerationEvaluationResultDto {
    /**
     * 
     * @type {string}
     * @memberof EnumerationEvaluationResultDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof EnumerationEvaluationResultDto
     */
    readonly creationTime?: string;
    /**
     * 
     * @type {number}
     * @memberof EnumerationEvaluationResultDto
     */
    readonly creatorUserId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof EnumerationEvaluationResultDto
     */
    lastModificationTime?: string | null;
    /**
     * 
     * @type {number}
     * @memberof EnumerationEvaluationResultDto
     */
    readonly lastModifierUserId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof EnumerationEvaluationResultDto
     */
    evaluationParameterId?: string;
    /**
     * 
     * @type {string}
     * @memberof EnumerationEvaluationResultDto
     */
    name?: string | null;
    /**
     * 
     * @type {EvaluationState}
     * @memberof EnumerationEvaluationResultDto
     */
    evaluationOutcome?: EvaluationState;
    /**
     * 
     * @type {EntityOrigin}
     * @memberof EnumerationEvaluationResultDto
     */
    origin?: EntityOrigin;
    /**
     * 
     * @type {string}
     * @memberof EnumerationEvaluationResultDto
     */
    iuid?: string | null;
    /**
     * 
     * @type {BeamConstancyWorkResultDtoCreatorUser}
     * @memberof EnumerationEvaluationResultDto
     */
    creatorUser?: BeamConstancyWorkResultDtoCreatorUser | null;
    /**
     * 
     * @type {BeamConstancyWorkResultDtoCreatorUser}
     * @memberof EnumerationEvaluationResultDto
     */
    lastModifierUser?: BeamConstancyWorkResultDtoCreatorUser | null;
    /**
     * 
     * @type {string}
     * @memberof EnumerationEvaluationResultDto
     */
    dataSetId?: string;
    /**
     * 
     * @type {number}
     * @memberof EnumerationEvaluationResultDto
     */
    commentCount?: number | null;
    /**
     * 
     * @type {string}
     * @memberof EnumerationEvaluationResultDto
     */
    lastComment?: string | null;
    /**
     * 
     * @type {number}
     * @memberof EnumerationEvaluationResultDto
     */
    commentAttachmentsCount?: number | null;
    /**
     * 
     * @type {Array<PtwCommentDto>}
     * @memberof EnumerationEvaluationResultDto
     */
    comments?: Array<PtwCommentDto> | null;
    /**
     * 
     * @type {EnumerationOptionDto}
     * @memberof EnumerationEvaluationResultDto
     */
    selectedOption?: EnumerationOptionDto;
    /**
     * 
     * @type {string}
     * @memberof EnumerationEvaluationResultDto
     */
    $type?: EnumerationEvaluationResultDtoTypeEnum;
}


/**
 * @export
 */
export const EnumerationEvaluationResultDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedJobExecutionDtoEnumerationEvaluationResultDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.JobExecution.Dto.EnumerationEvaluationResultDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type EnumerationEvaluationResultDtoTypeEnum = typeof EnumerationEvaluationResultDtoTypeEnum[keyof typeof EnumerationEvaluationResultDtoTypeEnum];



/**
 * Check if a given object implements the EnumerationEvaluationResultDto interface.
 */
export function instanceOfEnumerationEvaluationResultDto(value?: unknown): value is EnumerationEvaluationResultDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(EnumerationEvaluationResultDtoTypeEnum)[0];
}

export function EnumerationEvaluationResultDtoFromJSON(json: any): EnumerationEvaluationResultDto {
    return EnumerationEvaluationResultDtoFromJSONTyped(json, false);
}

export function EnumerationEvaluationResultDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): EnumerationEvaluationResultDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'creationTime': json['creationTime'] == null ? undefined : json['creationTime'],
        'creatorUserId': json['creatorUserId'] == null ? undefined : json['creatorUserId'],
        'lastModificationTime': json['lastModificationTime'] == null ? undefined : json['lastModificationTime'],
        'lastModifierUserId': json['lastModifierUserId'] == null ? undefined : json['lastModifierUserId'],
        'evaluationParameterId': json['evaluationParameterId'] == null ? undefined : json['evaluationParameterId'],
        'name': json['name'] == null ? undefined : json['name'],
        'evaluationOutcome': json['evaluationOutcome'] == null ? undefined : EvaluationStateFromJSON(json['evaluationOutcome']),
        'origin': json['origin'] == null ? undefined : EntityOriginFromJSON(json['origin']),
        'iuid': json['iuid'] == null ? undefined : json['iuid'],
        'creatorUser': json['creatorUser'] == null ? undefined : BeamConstancyWorkResultDtoCreatorUserFromJSON(json['creatorUser']),
        'lastModifierUser': json['lastModifierUser'] == null ? undefined : BeamConstancyWorkResultDtoCreatorUserFromJSON(json['lastModifierUser']),
        'dataSetId': json['dataSetId'] == null ? undefined : json['dataSetId'],
        'commentCount': json['commentCount'] == null ? undefined : json['commentCount'],
        'lastComment': json['lastComment'] == null ? undefined : json['lastComment'],
        'commentAttachmentsCount': json['commentAttachmentsCount'] == null ? undefined : json['commentAttachmentsCount'],
        'comments': json['comments'] == null ? undefined : ((json['comments'] as Array<any>).map(PtwCommentDtoFromJSON)),
        'selectedOption': json['selectedOption'] == null ? undefined : EnumerationOptionDtoFromJSON(json['selectedOption']),
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function EnumerationEvaluationResultDtoToJSON(value?: Omit<EnumerationEvaluationResultDto, 'creationTime'|'creatorUserId'|'lastModifierUserId'> | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'id': value['id'],
        'lastModificationTime': value['lastModificationTime'],
        'evaluationParameterId': value['evaluationParameterId'],
        'name': value['name'],
        'evaluationOutcome': EvaluationStateToJSON(value['evaluationOutcome']),
        'origin': EntityOriginToJSON(value['origin']),
        'iuid': value['iuid'],
        'creatorUser': BeamConstancyWorkResultDtoCreatorUserToJSON(value['creatorUser']),
        'lastModifierUser': BeamConstancyWorkResultDtoCreatorUserToJSON(value['lastModifierUser']),
        'dataSetId': value['dataSetId'],
        'commentCount': value['commentCount'],
        'lastComment': value['lastComment'],
        'commentAttachmentsCount': value['commentAttachmentsCount'],
        'comments': value['comments'] == null ? undefined : ((value['comments'] as Array<any>).map(PtwCommentDtoToJSON)),
        'selectedOption': EnumerationOptionDtoToJSON(value['selectedOption']),
        '$type': value['$type'],
    });
}

